import React from "react";
import { Link } from "react-router-dom";
import MatchSummaryWide from "./MatchSummaryWide";

const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const getPrettyDate = (programDate) => {
  let d = new Date(programDate);
  return weekday[d.getDay()] + " " + d.getDate() + " " + monthName[d.getMonth()];
};
const manage_closing_time_error = (programDate, kickOffTime, PartitionKey, RowKey) => {
  if (PartitionKey === "ErrorPart" && RowKey === "ErrorRow") {
    return "Sun 1 Dec 15:30";
  } else {
    return getPrettyDate(programDate) + " " + kickOffTime;
  }
};

const PoolItemWide = ({ item }) => {
  return (
    <div>
      <div className="pooldateindicator4R">
        {getPrettyDate(item.programDate)} - {item.PartitionKey}
        <Link
          to={"/form-guides/previews-by-pool#" + item.programDate + "_" + item.programCode + "_" + item.race}
          style={{ float: "right", margin: "2px", fontSize: "0.85em", color: "#fafafa" }}
        >
          Read Pool Preview
        </Link>
      </div>
      <table className="pooltable">
        <tbody>
          <tr>
            <th>Match</th>
            <th>Team A</th>
            <th className="centertext">v</th>
            <th className="righttext">Team B</th>
          </tr>
          {JSON.parse(item.matches).map((match) => (
            <MatchSummaryWide item={match} pool_title={item.PartitionKey} />
          ))}
        </tbody>
      </table>
      <div className="panel poolinformation">
        Betting Opens: {getPrettyDate(item.poolOpenDate)}
        <br />
        Closes: {manage_closing_time_error(item.programDate, item.kickOffTime)}
        <br />
        Current Pool: {item.poolTotal}
        <br />
        Status: {item.poolStatus}. Pool Code {item.programCode}
        <br />
        {item.poolStatus === "OPEN" ? (
          <a
            href={"https://www.tab.co.za/tabs/soccer/" + item.programDate + "/" + item.programCode + "/" + item.race}
            className="button button4R tiny right betnowbutton"
            rel="noopener noreferrer"
          >
            BET NOW
          </a>
        ) : item.poolStatus === "CLOSED" ? (
          <Link
            to={"/live-pool-projections#" + item.programDate + "_" + item.programCode + "_" + item.race}
            style={{ backgroundColor: "tomato" }}
            className="button tiny right"
          >
            VIEW LIVE
          </Link>
        ) : (
          ""
        )}
        {item.free2Play ? (
          <a
            href={"https://www.tab.co.za/tabs/free/" + item.programDate + "/" + item.programCode + "/" + item.race}
            className="left"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://www.tab.co.za/assets/free-to-play/f2p-logo-blue.png"
              alt="free-2-play"
              style={{ width: "73px", height: "43px", marginTop: "15px" }}
            />
          </a>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default PoolItemWide;
